type ExportFileType = 'csv' | 'xlsx' | 'docx' | 'html';

type DownloadFileAsBlobConfig = {
  fileName: string;
  fileType: ExportFileType;
};

export const downloadBlobFile = (file: Blob, config: DownloadFileAsBlobConfig) => {
  const url = window.URL.createObjectURL(new Blob([file]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', `${config.fileName}.${config.fileType}`);
  document.body.appendChild(link);
  link.click();
  link.remove();
};
